import AddIcon from '@mui/icons-material/Add';
import DeleteButton from '../../components/DeleteButton';
import DeleteIconButton from '../../components/DeleteIconButton';
import { Button, FormControlLabel, Grid, InputLabel, Switch, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React from 'react';

import QuillEditor from '../../components/QuillEditor';
import StyledFilledTextField from '../../components/StyledFilledTextField';
import { ContextStore } from '../../store/contextStore';
import { asJSONPath } from '../../utils';
import TripFlowTimeSlot from './TripEditFlowTimeSlot';
import UploadKMLFileButton from './UploadKMLFileButton';
import useConfirmDialog from '../../components/useConfirmDialog';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 0,
        maxWidth: '874px',
    },
    deleteDayButton: {
        [theme.breakpoints.up('lg')]: {
            position: 'absolute !important',
            right: 50,
            top: 122,
        },
    },
    addStopButton: {
        border: 'solid 1px #D8D8D8 !important',
        borderRadius: '8px !important',
        width: '184px !important',
        height: '40px !important',
        marginTop: '0.5rem !important',
    },
}));

const emptyTimeSlot = {
    activities: [{ activity: '', booking_state: null, confirmation: null, cost_max: null, cost_min: null, cost_prefix: null, cost_unit: null, currency: null, id: null, is_selected: false, payment_type: 0, price_level: null, price_type: 0, sequence: 1 }],
    description: '',
    footer: '',
    id: null,
    image: null,
    show_transport: false,
    next_transport: null,
    order_by: 1,
    subtitle: '',
    time: null,
    timeline_display: 0,
    timeline_type: {
        icon: null,
        id: 9,
        name: 'Show time',
        show_icon: false,
        show_label: false,
        show_time: true,
    },
    title: '',
    transport_text: '',
    type: 0,
    open: true,
};

const DEFAULT_TIME = '07:00:00';
const TIME_FORMAT = 'HH:mm:ss';

const TripFlowDay = (props) => {
    const [confirmDelete, confirmDeleteDialog] = useConfirmDialog();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { hasPerm } = React.useContext(ContextStore);

    // const day = props.day;
    // const dayNumber = +props.dayNumber;
    // const tripStartDate = props.startDate;
    const timeslots = props.day.timeslots || [];

    // const multipleDays = +day.day_span > 1;

    // const dayStartDate = tripStartDate.clone().add(dayNumber - 1, 'days');
    // const dayEndDate = dayStartDate.clone().add(day.day_span - 1, 'days');
    // const dayLabel = multipleDays ? `${dayStartDate.format('MMM D')}-${dayEndDate.format('MMM D')}` : dayStartDate.format('MMM D');

    const onTextChange = (ev) => {
        const newDay = { ...props.day, [ev.target.name]: ev.target.value };
        props.onChange && props.onChange(newDay, props.idx, ev);
    };

    const onAdd = (ev) => {
        const lastSlot = timeslots[timeslots.length - 1];
        const nextTime = moment(lastSlot && lastSlot.time ? lastSlot.time : DEFAULT_TIME, TIME_FORMAT)
            .add(1, 'hour')
            .format(TIME_FORMAT);

        // Can't use the same outer emptyTimeSlot object since it is being changed (#CP-4691)
        const emptyTimeSlot = {
            // #CP-4576
            // activities: [{ activity: '', booking_state: null, confirmation: null, cost_max: null, cost_min: null, cost_prefix: null, cost_unit: null, currency: null, id: null, is_selected: false, payment_type: 0, price_level: null, price_type: 0, sequence: 1 }],
            activities: [],
            description: '',
            footer: '',
            id: null,
            image: null,
            show_transport: false,
            next_transport: null,
            order_by: 1,
            subtitle: '',
            time: null,
            timeline_display: 0,
            timeline_type: {
                icon: null,
                id: 9,
                name: 'Show time',
                show_icon: false,
                show_label: false,
                show_time: true,
            },
            title: '',
            transport_text: '',
            type: 0,
            open: true,
        };

        const newSlot = { ...emptyTimeSlot, time: nextTime };
        props.onChange && props.onChange(asJSONPath(`timeslots[${timeslots.length}]`, newSlot), props.idx);
        // const newDay = {
        //     // ...props.day,
        //     timeslots: timeslots.concat({
        //         ...emptyTimeSlot,
        //         time: moment(lastSlot && lastSlot.time ? lastSlot.time : DEFAULT_TIME, TIME_FORMAT).add(1, 'hour').format(TIME_FORMAT)
        //     }),
        // }
        // props.onChange && props.onChange(newDay, props.idx, ev);
    };

    const onDelete = (slot, idx) => {
        props.onChange &&
            props.onChange(
                {
                    ...props.day,
                    timeslots: timeslots.filter((ts, i) => i !== idx),
                },
                props.idx
            );
    };

    const onDayDelete = async (ev) => {
        if (await confirmDelete({ body: 'Do you really want to remove this day?', okButtonText: 'Remove day', destructive: true })) {
            props.onDelete && props.onDelete(props.day, props.idx);
        }
    };

    const onSlotChange = (slot, idx) => {
        props.onChange && props.onChange(asJSONPath(`timeslots[${idx}]`, slot), props.idx);
        // {
        //     // ...props.day,
        //     timeslots: timeslots.map((ts, i) => (i === idx ? slot : ts))
        // }), props.idx);
    };

    const onKMLFileSelect = (file, prevfile) => {
        props.onChange &&
            props.onChange(
                {
                    [`kml_day_${props.idx}_`]: file,
                    kml_file: file,
                },
                props.idx
            );
    };

    const onValidateTimeslot = (key, canSave, errors) => {
        props.onValidate && props.onValidate(`days[${props.idx}].${key}`, canSave, errors);
    };

    const timeSlotList =
        timeslots.length > 0 ? (
            timeslots.map((ts, idx) => (
                <React.Fragment key={idx}>
                    <TripFlowTimeSlot
                        disabled={props.disabled}
                        setNewDocsAdded={props.setNewDocsAdded}
                        newDocsAdded={props.newDocsAdded}
                        visibility={true}
                        slot={ts}
                        idx={idx}
                        day={props.day}
                        trip={props.trip}
                        onChange={onSlotChange}
                        onDelete={onDelete} onValidate={onValidateTimeslot} isSmallScreen={props.isSmallScreen} setClientErrors={props.setClientErrors}
                        isLastItem={idx === timeslots.length - 1}
                        />
                </React.Fragment>
            ))
        ) : (
            // skeleton slot to prevent shrinking in xl screens
            <TripFlowTimeSlot
                    disabled={props.disabled}
                setNewDocsAdded={props.setNewDocsAdded} newDocsAdded={props.newDocsAdded}
                visibility={false} slot={{ ...emptyTimeSlot }} idx={0} day={props.day} trip={props.trip} onChange={onSlotChange} onDelete={onDelete} onValidate={onValidateTimeslot} isSmallScreen={props.isSmallScreen} setClientErrors={props.setClientErrors} 
                isLastItem={true}
                />
        );



    const handleTimeslotExpand = () => {
        if (props.day.timeslots.filter((ts) => ts.open).length > 0) {
            props.onChange &&
                props.onChange(
                    {
                        ...props.day,
                        timeslots: timeslots.map((ts) => ({ ...ts, open: false })),
                    },
                    props.idx
                );
        } else {
            props.onChange &&
                props.onChange(
                    {
                        ...props.day,
                        timeslots: timeslots.map((ts) => ({ ...ts, open: true })),
                    },
                    props.idx
                );
        }
    };

    const handleDatePickerDates = (newDateRange) => {
        let start_date = newDateRange[0];
        let end_date = newDateRange[1];
        let difference_in_days = end_date ? moment(end_date).utc(true).diff(start_date, 'days') : 0

        props.onTripUpdate({
            ...props.trip,
            start_date: moment(start_date).format('YYYY-MM-DD'),
        });

        if (difference_in_days && difference_in_days >= 1) {
            onTextChange({ target: { name: 'day_span', value: difference_in_days + 1 } });
        } else {
            onTextChange({ target: { name: 'day_span', value: 1 } });
        }
    }


    return (
        <div className={classes.root}>
            {confirmDeleteDialog}
            <Grid container direction="row" spacing={props.isSmallScreen ? 1 : 2} alignItems="flex-start">
                <Grid item xs={10} lg={3} style={{ position: 'relative' }}>
                    {/* CP-8349: no start-date picker on a guide group -- its dates are synthetic
                        and the backend pins them; day 0 gets the plain Day Span field instead. */}
                    {props.trip.is_bespoke && !props.trip.is_staff_chat_group && props.idx === 0 ? (
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DateRangePicker
                                disabled={props.disabled}
                                slots={{ field: SingleInputDateRangeField }}
                                name="allowedRange"
                                variant="filled"
                                onChange={(dates) => handleDatePickerDates(dates)}
                                value={props.day.day_span > 1 ? [moment.utc(props.trip.start_date), moment.utc(props.trip.start_date).add(props.day.day_span - 1, 'days')] : [moment.utc(props.trip.start_date), null]}
                                // value={[moment.utc(props.trip.start_date), moment.utc(props.trip.start_date).add(props.day.day_span -1, 'days')]}
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'filled',
                                    },
                                    actionBar: {
                                        actions: ['accept'],
                                    },
                                }}
                            // timezone={props.trip.start_timezone}
                            />
                        </LocalizationProvider>
                    ) : (
                        <StyledFilledTextField
                                disabled={props.disabled}
                            variant="filled"
                            label="Day Span"
                            name="day_span"
                            size="small"
                            type="number"
                            fullWidth
                            value={props.day.day_span}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputProps: { min: 1, step: 1 },
                            }}
                            onChange={onTextChange}
                            helperText="Must be > 0"
                        />
                    )}
                </Grid>
                {props.isSmallScreen && (
                    <Grid item xs={2} justifyContent="flex-end">
                        <DeleteIconButton title="Remove day" size="medium" onClick={onDayDelete} disabled={props.disabled} />
                    </Grid>
                )}
                <Grid item xs={12} lg={5}>
                    <StyledFilledTextField disabled={props.disabled} fullWidth variant="filled" size="small" label="Day Title (optional)" name="title" value={props.day.title} onChange={onTextChange} />
                </Grid>
                {!props.isSmallScreen && <Grid item xs={10} lg={1}></Grid>}
                {!props.isSmallScreen && (
                    <Grid item xs={2} lg={3} container justifyContent="flex-end" pb={3} alignItems="center" className={classes.deleteDayButton}>
                        <DeleteButton onClick={onDayDelete} disabled={props.disabled}>
                            Remove day
                        </DeleteButton>
                    </Grid>
                )}
                <Grid item xs={12} lg={8}>
                    <StyledFilledTextField disabled={props.disabled} fullWidth variant="filled" size="small" label="Day Subtitle (optional)" multiline name="subtitle" value={props.day.subtitle} onChange={onTextChange} />
                </Grid>
                <Grid item xs={12} lg={8}>
                    <InputLabel style={{ marginBottom: '-0.5rem' }} shrink>Description</InputLabel>
                    {props.disabled ?
                        <StyledFilledTextField disabled={true} fullWidth variant="filled" size="small" multiline value={props.day.description} onChange={onTextChange} />
                        :
                    <QuillEditor
                        value={props.day.description}
                        onChange={(html) => onTextChange({ target: { name: 'description', value: html } })}
                        />}
                </Grid>
                {!props.isSmallScreen && <Grid item xs={4}></Grid>}
                <Grid item xs={12}>
                    <UploadKMLFileButton disabled={props.disabled} file={props.day.kml_file} onSelect={!hasPerm('tour', 'write') ? () => enqueueSnackbar('You do not have permission to edit trips', { variant: 'error' }) : onKMLFileSelect} accept=".kml, *.kmz" />
                </Grid>
                <Grid item xs={12}>
                    {timeSlotList.length > 1 && (
                        <Grid item>
                            <FormControlLabel disabled={props.disabled} control={<Switch checked={props.day.timeslots.filter((ts) => ts.open).length > 0} onClick={handleTimeslotExpand} />} label="Open all stops" />
                        </Grid>
                    )}
                    {timeSlotList}
                    <Grid item>
                        {!props.disabled && (
                            <Button className={classes.addStopButton} onClick={onAdd}>
                                <AddIcon sx={{ fontSize: 16 }} />
                                <Typography fontSize={14} fontWeight={500} pl={1} pt={0.25}>
                                    Add Stop
                                </Typography>
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default TripFlowDay;
